module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-actionsheet"
  }, [_c('transition', {
    attrs: {
      "name": "vux-actionsheet-mask"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask weui-mask_transparent",
    on: {
      "click": _vm.onClickingMask
    }
  })]), _vm._v(" "), (_vm.theme === 'android') ? _c('div', {
    staticClass: "weui-skin_android"
  }, [_c('transition', {
    attrs: {
      "name": "vux-android-actionsheet"
    },
    on: {
      "after-enter": function($event) {
        _vm.$emit('on-after-show')
      },
      "after-leave": function($event) {
        _vm.$emit('on-after-hide')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-actionsheet"
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, _vm._l((_vm.menus), function(text, key) {
    return _c('div', {
      staticClass: "weui-actionsheet__cell",
      domProps: {
        "innerHTML": _vm._s(text.label || text)
      },
      on: {
        "click": function($event) {
          _vm.onMenuClick(text, key)
        }
      }
    })
  }))])])], 1) : _c('div', {
    ref: "iOSMenu",
    staticClass: "weui-actionsheet",
    class: {
      'weui-actionsheet_toggle': _vm.show
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, [(_vm.hasHeaderSlot) ? _c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.menus), function(text, key) {
    return _c('div', {
      staticClass: "weui-actionsheet__cell",
      class: ("vux-actionsheet-menu-" + (text.type || 'default')),
      domProps: {
        "innerHTML": _vm._s(text.label || text)
      },
      on: {
        "click": function($event) {
          _vm.onMenuClick(text, key)
        }
      }
    })
  })], 2), _vm._v(" "), (_vm.showCancel) ? _c('div', {
    staticClass: "weui-actionsheet__action",
    on: {
      "click": function($event) {
        _vm.emitEvent('on-click-menu', 'cancel')
      }
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14ba237a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/actionsheet/index.vue
// module id = 518
// module chunks = 0